import { ChainId } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useMemo } from 'react';

export const useIsWrongNetwork = () => {
  const desiredNetwork = currentWallet.useDesiredNetwork();
  const chainId: ChainId | undefined = currentWallet.useChainId();

  return useMemo(() => {
    const allowedChainIds =
      desiredNetwork === ChainId.ETHEREUM
        ? [ChainId.ETHEREUM, ChainId.CRONOS_EVM_MAINNET, ChainId.ZK_EVM]
        : [ChainId.SEPOLIA, ChainId.ZK_EVM_TEST, ChainId.CRONOS_EVM_TESTNET];

    return chainId && !allowedChainIds.includes(chainId);
  }, [chainId, desiredNetwork]);
};
